import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[directiveEmail]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: EmailValidatorDirective,
      multi: true
    }
  ]
})
export class EmailValidatorDirective implements Validator {
  private readonly emailRegex = new RegExp(environment.commonSetting.emailRegex);

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Don't validate if the field is empty (handled by `required`).
    }
    const isValid = this.emailRegex.test(control.value);
    return isValid ? null : { invalidEmail: true };
  }
}
